import Backdrop from '@material-ui/core/Backdrop';
import Box from '@material-ui/core/Box';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '95%',
    maxWidth: '480px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: '8px',
};

const useStyles = makeStyles(() => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));

/**
 * Aviso informativo tras guardar la grilla: vehículos incluidos que ya tienen un ticket de
 * mantenimiento abierto no van a recibir un ticket automático hasta que se resuelva el actual.
 *
 * Props:
 *   open     {boolean}
 *   cantidad {number}
 *   onClose  {function}
 */
const ProgramasPreventivosTicketAbiertoModal = (props) => {
    const classes = useStyles();

    return (
        <Modal
            open={props.open}
            onClose={props.onClose}
            className={classes.modal}
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 500 }}
        >
            <Fade in={props.open}>
                <Box sx={modalStyle}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="mb-0">
                            <i className="fa fa-wrench"></i>{' '}
                            <FormattedMessage id="programasPreventivos.modal.ticket_abierto.titulo" defaultMessage="Vehículos con ticket abierto" />
                        </h4>
                        <button type="button" className="close" onClick={props.onClose} aria-label="close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div className="alert alert-warning" style={{ fontSize: '13px' }}>
                        <i className="fa fa-exclamation-triangle"></i>{' '}
                        <FormattedMessage
                            id="programasPreventivos.modal.ticket_abierto.mensaje"
                            defaultMessage="{cantidad} vehículos incluidos ya tienen un ticket de mantenimiento abierto. No se les va a generar un ticket automático hasta que se resuelva el actual."
                            values={{ cantidad: props.cantidad }}
                        />
                    </div>

                    <div className="text-right mt-3">
                        <button type="button" className="btn btn-primary" onClick={props.onClose}>
                            <FormattedMessage id="programasPreventivos.modal.ticket_abierto.btn_entendido" defaultMessage="Entendido" />
                        </button>
                    </div>
                </Box>
            </Fade>
        </Modal>
    );
};

export default ProgramasPreventivosTicketAbiertoModal;
